import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=2c903fa3&scoped=true"
import script from "./ReviewPage.vue?vue&type=script&lang=js"
export * from "./ReviewPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=2c903fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c903fa3",
  null
  
)

export default component.exports